export default [
  {
    path: '/support-tickets',
    name: 'support-tickets-list',
    component: () => import(/* webpackChunkName: "SupportTicketsList" */ '@/views/support-tickets/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,support-tickets',
    },
  },
  {
    path: '/support-tickets/:uuid',
    name: 'support-tickets-detail',
    component: () => import(/* webpackChunkName: "SupportTicketsDetail" */ '@/views/support-tickets/detail.vue'),
    meta: {
      layout: 'content',
      module: 'MGN,support-tickets',
    },
  },
]
